<template>
    <label class="switch">
        <input
            type="checkbox"
            @input="toggle"
            :checked="value"
        >
        <span class="slider round" :class="{ active: value }"></span>
    </label>
</template>

<script>
    export default {
        props: {
            value: {
              type: Boolean
            }
        },
        methods: {
            toggle() {
                this.$emit('input', !this.value);
            }
        }
    }
</script>
